export default __webpack_public_path__ + "static/media/AdStorm_04.cbf34d52.png";